import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import s from './WithMarkdown.module.scss';
export const WithMarkdown = _ref => {
  let {
    children = ''
  } = _ref;
  return /*#__PURE__*/React.createElement(ReactMarkdown, {
    className: s.container,
    remarkPlugins: [remarkGfm],
    components: {
      a: _ref2 => {
        let {
          node,
          children: linkText,
          ...props
        } = _ref2;
        return /*#__PURE__*/React.createElement("a", _extends({}, props, {
          target: "_blank"
        }), linkText);
      }
    }
  }, children);
};
//# sourceMappingURL=WithMarkdown.js.map